export default {
  title: "Carrusel",
  subtitle: "Diapositivas del carrusel del kiosco por región.",
  empty: "Aún no hay diapositivas para esta región.",
  emptyWritable: "Crea la primera diapositiva del carrusel para esta región.",
  schedule: {
    always: "Siempre",
    from: "Desde",
    until: "Hasta",
  },
  columns: {
    slide: "Diapositiva",
    audience: "Destino",
    schedule: "Horario",
    status: "Estado",
  },
  status: {
    visible: "Visible ahora",
    enabled: "Activada",
    disabled: "Desactivada",
    scheduled: "Programada",
    expired: "Finalizada",
    draft: "Borrador",
  },
  statusHints: {
    draft:
      "Guardada como borrador — no está publicada, así que no aparece en los kioscos.",
    visible:
      "En vivo en los kioscos ahora mismo (activada y dentro del horario).",
    scheduled:
      "Tiene una hora de inicio futura. Aparecerá en los kioscos cuando llegue esa hora, si Activada está encendida.",
    disabled:
      "No se muestra en los kioscos — Activada está apagada, o ya pasó la hora de fin.",
  },
  categories: {
    all: "Todas las pestañas",
    select: "Seleccionar pestañas",
  },
  structures: {
    all: "Todas las estructuras",
    count: "{{count}} estructuras",
  },
  actions: {
    create: "Nueva diapositiva",
    edit: "Editar",
    delete: "Eliminar",
    dragToReorder: "Arrastrar para reordenar",
  },
  form: {
    createTitle: "Nueva diapositiva del carrusel",
    createDescription: "Diapositiva para los kioscos de la región {{region}}.",
    editTitle: "Editar diapositiva del carrusel",
    sections: {
      content: "Texto",
      contentHint: "Título y descripción localizados de la diapositiva.",
      media: "Medios",
      mediaHint:
        "Obligatoria para publicar salvo que haya una actividad vinculada (entonces se usa su foto).",
      activity: "Actividad vinculada",
      activityHint:
        "Opcional. Busca una actividad para el CTA y la foto de respaldo.",
      targeting: "Segmentación",
      targetingHint: "En qué pestañas y estructuras se muestra.",
      visibility: "Visibilidad",
      visibilityHint: "Activa la diapositiva y programa cuándo aparece.",
    },
    titleLabel: "Título",
    descriptionLabel: "Descripción (opcional)",
    photoCropDescription:
      "Encuadre la foto para el banner del carrusel de inicio del kiosco (5:2).",
    activitySearch: "Buscar por nombre, titular o categoría…",
    activityNoResults: "Ninguna actividad coincide con la búsqueda.",
    activityListEmpty: "No hay actividades en esta región.",
    activityClear: "Quitar actividad vinculada",
    activityChange: "Cambiar",
    activityInactive: "Inactiva",
    showButton: "Mostrar botón para abrir la actividad",
    showButtonHint:
      "Añade un botón en la diapositiva que abre el detalle de la actividad vinculada.",
    ignoreDistance: "Ignorar distancia",
    ignoreDistanceHint:
      "Mantén esta diapositiva en el carrusel aunque la actividad vinculada esté lejos del kiosco.",
    categoriesLabel: "Pestañas de inicio",
    categoriesHint:
      "Selecciona al menos una pestaña. Por defecto están todas seleccionadas para mostrarla en todas partes. Al vincular una actividad se usa su categoría.",
    showInAllStructures: "Mostrar en todas las estructuras",
    showInAllStructuresHint:
      "Si está desactivado, elige en qué estructuras se muestra. Si está activado, la ven todas las estructuras de la región.",
    structuresLabel: "Estructuras",
    structuresHint:
      "Elige en qué estructuras se puede mostrar esta diapositiva.",
    enabled: "Activada",
    enabledHint:
      "Si está desactivada, la diapositiva no se muestra en los kioscos aunque esté publicada y dentro del horario.",
    startsAt: "Inicio (opcional)",
    endsAt: "Fin (opcional)",
    clearSchedule: "Borrar",
    translate: "Generar traducciones",
    incompleteTranslationsTitle: "Traducciones incompletas",
    incompleteTranslationsBody:
      "El título debe estar en todos los idiomas. La descripción debe estar completa en todos o vacía. Genera el texto que falta a partir del idioma que ya escribiste, o termínalo a mano.",
  },
  delete: {
    title: "¿Eliminar diapositiva?",
    body: "“{{title}}” se eliminará permanentemente del carrusel.",
    confirm: "Eliminar",
    success: "Diapositiva eliminada",
  },
  toast: {
    created: "Diapositiva creada",
    updated: "Diapositiva guardada",
    draftSaved: "Borrador guardado",
    reordered: "Orden actualizado",
  },
  errors: {
    loadError: "No se pudieron cargar las diapositivas",
    titleRequired: "El título es obligatorio en todos los idiomas",
    titleRequiredDraft: "Añade un título en al menos un idioma",
    descriptionPartial:
      "La descripción debe estar completa en todos los idiomas o vacía",
    photoRequired: "Sube una foto o vincula una actividad para usar la suya.",
    categoriesRequired: "Selecciona al menos una pestaña de inicio",
    structuresRequired:
      "Selecciona al menos una estructura, o muéstralo en todas",
    saveFailed: "No se pudo guardar la diapositiva",
  },
} as const;
